/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { useState } from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { Button, Dialog, DialogTitle, DialogContent, TextField, Stack } from '@material-ui/core';

import { useDispatch, useSelector } from 'react-redux';
// eslint-disable-next-line import/no-unresolved
import {
  createCampaignRuleParent
  // eslint-disable-next-line import/no-unresolved
} from 'src/redux/slices/campaignrules';

SaveSegementRuleDialog.propType = {
  btnName: PropTypes.string,
  title: PropTypes.string,
  icon: PropTypes.object
};

export default function SaveSegementRuleDialog({ id, btnName = 'Add', title = '', segmentRules }) {
  const [open, setOpen] = useState(false);
  const [fullWidth] = useState(true);
  const [maxWidth] = useState('sm');
  const { appliedRuleFile } = useSelector((state) => state.collection);
  const today = format(new Date(), 'ddMMyyyy-HHmmss');
  const defaultname = `CR-${appliedRuleFile?.project_details?.project_name}-${today}`;
  const [ruleName, setRuleName] = useState(defaultname);
  const dispatch = useDispatch();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleNameChange = (e) => {
    setRuleName(e.target.value);
  };

  const handleSubmit = () => {
    if (ruleName !== null) {
      const NameObj = {
        campaign_rule_name: ruleName,
        project: appliedRuleFile?.project_details?.id
      };
      dispatch(createCampaignRuleParent(NameObj, segmentRules));
    }
    handleClose();
  };
  return (
    <>
      <Button onClick={() => handleClickOpen()} size="small" variant="outlined">
        {btnName}
      </Button>
      <Dialog open={open} maxWidth={maxWidth} onClose={handleClose} fullWidth={fullWidth}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent style={{ padding: '24px' }}>
          <Stack direction={{ xs: 'colum', md: 'column' }} spacing={{ xs: 1, md: 2 }}>
            <TextField
              label="Enter Campaign Rule Set Name"
              name="campName"
              value={ruleName}
              onChange={handleNameChange}
            />
            <Stack direction={{ xs: 'colum', md: 'row' }} spacing={{ xs: 1, md: 2 }} justifyContent="flex-end">
              <Button variant="contained" onClick={() => handleClose()}>
                Cancel
              </Button>
              <Button variant="contained" onClick={handleSubmit}>
                Save
              </Button>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
}
